// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>15</span>&nbsp;&nbsp;But it was even you, one like myself,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;my companion and my own familiar friend.<br> </p> </div></div>";
// Exports
module.exports = code;